import './style.css';

interface IProps {
  label: string;
  bgColor?: string;
  textColor?: string;
  onClick?: () => void;
}

const AppTag = ({ label, bgColor, textColor, onClick }: IProps) => {
  return (
    <div
      className="app-tag"
      style={{
        backgroundColor: bgColor || '#4A90E2',
        color: textColor || '#FFFFFF',
      }}
      onClick={onClick}
    >
      <p>{label}</p>
    </div>
  );
};

export default AppTag;
